import axios from 'axios'; // 引入axios

export default {
    data() {
        return {
            baseUrl: this.$global.baseUrl,
            searchContent: "",
            tableData: [],
            total: 0,
            pageIndex: 1,
            pageSize: 12,
            dialogManageShow: false,
            manageForm: {},
            multipleSelection: [],
            dialogImageShow: false,
            searchLoading: false,
            userList: [],
            uploadFileList: [],
            certificateImage: null
        }
    },
    mounted: function() {
        this.query();
    },
    methods: {
        clickEvent: function(id, data) {
            switch (id) {
                case "search": //搜索
                    this.pageIndex = 1;
                    this.query();
                    break;
                case "add": //添加
                    this.manageForm = { score: 60 };
                    this.dialogManageShow = true;
                    break;
                case "manageConfirm": //确定
                    this.$refs['manageForm'].validate((valid) => {
                        if (valid) {
                            this.save();
                        } else {
                            return false;
                        }
                    });
                    break;
                case "delete": //删除
                    if (this.multipleSelection.length == 0) {
                        this.$message.closeAll();
                        this.$message.warning("请至少选择一项进行删除");
                        return;
                    }
                    this.$confirm('此操作将删除所选中的证书颁发记录, 是否继续?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        this.delete();
                    }).catch(() => {});
                    break;
                case "certificateImage": //查看证书文件
                    this.certificateImage = data;
                    this.dialogImageShow = true;
                    break;
                default:
                    break;
            }
        },

        /**
         * 格式化日期
         */
        formatDate: function(str) {
            return str.substring(0, 10)
        },

        /**
         * table选中事件
         * @param {*} val 
         */
        tableColumnCheckEvent: function(val) {
            this.multipleSelection = val;
        },

        /**
         * 翻页
         * @param {*} val 
         */
        handlePageChange: function(val) {
            this.pageIndex = val;
            this.query();
        },

        /**
         * 上传失败
         * @param {*} files 
         * @param {*} fileList 
         */
        handleError: function(err, file, fileList) {
            this.$message.closeAll();
            this.$message.error("上传失败");
        },

        /**
         * 上传成功
         * @param {*} response 
         * @param {*} file 
         * @param {*} fileList 
         */
        handleSuccess: function(response, file, fileList) {
            this.uploadFileList = [];
            if (response.success) {
                //调用导入
                this.excelImport(response.data.id);
            } else {
                this.$message.closeAll();
                this.$message.error(response.message);
            }
        },

        /**
         * 调用证书导入
         * @param {*} fileInfoId 
         */
        excelImport: function(fileInfoId) {
            axios.defaults.timeout = 600000; // 配置10分钟导入请求时间
            const loading = this.$loading({
                lock: true,
                text: '生成中，请稍后',
                spinner: 'el-icon-loading',
                background: 'rgba(255, 255, 255, 0.7)'
            });
            this.$post({
                url: 'certificate_record/excel_import',
                params: {
                    id: fileInfoId
                }
            }).then(response => {
                loading.close();
                this.$message.closeAll();
                this.$message.success("生成成功");
                this.pageIndex = 1;
                this.query();
            });
        },

        /**
         * 查询人员列表
         */
        queryUserList: function(query) {
            if (query == "")
                return;
            this.searchLoading = true;
            this.$post({
                url: 'user/queryByPage',
                params: {
                    keyWord: query,
                    pageIndex: 1,
                    pageSize: 10000
                }
            }).then(response => {
                this.searchLoading = false;
                this.userList = response.data;
            });
        },

        /**
         * 新增
         */
        save: function() {
            this.$post({
                url: "/certificate_record/save",
                params: {
                    userId: this.manageForm.userId,
                    score: this.manageForm.score,
                    toDate:this.manageForm.toDate
                }
            }, true).then(res => {
                this.manageForm = {};
                this.dialogManageShow = false;
                this.$message.closeAll();
                this.$message.success("证书颁发成功");
                this.query();
            });
        },

        /**
         * 批量删除
         */
        delete: function() {
            var ids = new Array();
            this.multipleSelection.forEach(elem => {
                ids.push(elem.id);
            });
            this.$post({
                url: "/certificate_record/delete",
                params: {
                    ids: ids
                }
            }).then(res => {
                this.$message.closeAll();
                this.$message.success("删除成功");
                this.query();
            });
        },

        /**
         * 查询
         */
        query: function() {
            this.$post({
                url: 'certificate_record/queryByPage',
                params: {
                    keyWord: this.searchContent,
                    pageIndex: this.pageIndex,
                    pageSize: this.pageSize
                }
            }, true).then(response => {
                this.total = response.total;
                this.tableData = response.data;
            });
        }
    }
}